import { useEffect, useState } from 'react';
import AuthModuleFactory from '@core/domain/Auth';
import RecaptchaComponent from '@app/components/Recaptcha';

const getSiteKeyUseCase = AuthModuleFactory.createGetRecaptchaSiteKeyUseCase();

export default function Recaptcha({ name, onChange }) {
  const [siteKey, setSiteKey] = useState(null);

  useEffect(() => {
    getSiteKeyUseCase.subscribeToUpdate(key => setSiteKey(key));
  }, []);

  useEffect(() => {
    getKey();
    return getSiteKeyUseCase.abort;
  }, []);

  const getKey = () => {
    getSiteKeyUseCase
      .execute()
      .then(res => setSiteKey(res))
      .catch(() => {});
  };

  const handleOnChange = value => {
    if (typeof value === 'string') onChange({ name, value });
  };

  const handleOnExpired = () => getKey();

  if (!siteKey) return null;
  return <RecaptchaComponent className="recaptcha" onExpired={handleOnExpired} sitekey={siteKey} onChange={handleOnChange} />;
}
